export default __webpack_public_path__ + "static/media/posts.ac4f39e7.svg";